<style>
  .c-input-signature canvas {
  }

  .c-input-signature-image {
    display: inline-block;
  }

  .c-input-signature-container {
    border:1px solid #dddddd;
  }

  .c-input-signature small {
    padding: 5px;
  }
</style>

<template>
  <div class="c-input-signature-image">
    <b-form-group
            :description="description"
            :label="label">
      <div class="c-input-signature-image-container mb-2">
        <small v-if="getSrc===''" >{{ Core.Definition.getDefinition('Sélectionnez une signature') }}</small>
        <img v-if="getSrc!==''" width="100%" :src="getSrc" />
      </div>
      <b-button-group>
        <b-button class="btn-sm btn mt-1" @click="add" variant="light">{{ Core.Definition.getDefinition('Ajouter') }}</b-button>
        <b-button class="btn-sm btn mt-1" @click="clear" variant="danger">{{ Core.Definition.getDefinition('Effacer') }}</b-button>
      </b-button-group>
    </b-form-group>

    <b-modal :no-close-on-backdrop="true" :title="Core.Definition.getDefinition('Liste des signatures')" :no-close-on-esc="true" :hide-footer="true" v-model="dataShow">
      <DynamicList
              ref="dynamicList"
              :searchFormStructure="dataSearchFormStructure"
              :columns="dataColumns"
              :edit="dataEdit"
              root="/binder-pdf-signature/list">
      </DynamicList>
    </b-modal>

  </div>

</template>

<script>
  import DynamicList from './DynamicList'
  import Vue from 'vue'
  export default {
    name: 'InputSignatureImage',
    components: {
      DynamicList
    },
    props: {
      id: {
        type: String,
        default: ''
      },
      label: {
        type: String,
        default: ''
      },
      description: {
        type: String,
        default: ''
      },
      value: {
        type: Array,
        default: function() {
          return []
        }
      },
      imgWidth: {type: Number, default: 200}
    },
    watch: {
      value(val) {
        this.dataValue = val
      },
      dataValue(val) {
        this.$emit('input', val)
      }
    },
    computed: {
      getSrc() {
        let image = ''
        if(Array.isArray(this.dataValue)) {
          if(this.dataValue[0]!== undefined) {
            if(this.dataValue[0].src !== undefined) {
              image = this.dataValue[0].src
            }
          }
        }
        return image
      }
    },
    mounted () {
      this.dataValue = this.value
    },
    data () {
      return {
        Core: window.Core,
        dataShow: false,
        dataValue: [],
        dataColumns: [
          {
            label: Core.Definition.getDefinition('ID'),
            key: 'id',
            sortable: true
          },
          {
            label: Core.Definition.getDefinition('Titre'),
            key: 'title',
            sortable: true
          },
          {
            label: Core.Definition.getDefinition('Date de création'),
            key: 'creationDate',
            type: 'date',
            sortable: true
          }
        ],
        dataSearchFormStructure: {
        },
        dataEdit: {
          show: true,
          text: '<button class="btn btn-sm btn-info"><i class="fa fa-plus"></i></button>',
          onClick:  this.onSelect
        }
      }
    },
    methods: {
      onSelect(value, cell, row) {
        let image = row.image
        if(!Array.isArray(image)) {
          image = JSON.parse(image)
        }
        if (Array.isArray(image)) {
          this.dataValue = image
        }
        this.dataShow = false
      },
      add() {
        this.dataShow = true
      },
      clear() {
        this.dataValue = []
      }
    }
  }
</script>


